import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { setCurrentGroup } from '@/slices/execVariableSlice';

function Group({ groups, currentGroup, setCurrentGroup }) {
  return (
    <Root>
      <Title>变量组</Title>
      <Content className='narrow-scrollbar'>
        {groups.map((item) => (
          <Item
            onClick={() => setCurrentGroup(item)}
            active={currentGroup?.id === item.id}
            key={item.id}
          >
            <Label>{item.groupName}</Label>
          </Item>
        ))}
      </Content>
    </Root>
  );
}

export default connect(
  (state) => ({
    groups: state.execVariable.groups,
    currentGroup: state.execVariable.currentGroup,
  }),
  {
    setCurrentGroup,
  },
)(Group);

const Root = styled.div`
  width: 220px;
  min-height: 400px;
  padding: 24px 0 24px 1px;
  border-right: 2px solid #edeff2;
`;

const Title = styled.div`
  color: var(--td-font-gray-1);
  font-size: 14px;
  padding: 0 20px;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div``;

const Item = styled.div`
  height: 33px;
  line-height: 33px;
  font-size: 13px;
  padding: 0 10px 0 24px;
  cursor: pointer;
  position: relative;
  display: flex;
  ${(props) =>
    props.active &&
    ` 
      background: #F7F8FA;
      color: var(--td-brand-color-7);
      font-weight: bold;
      padding-right: 8px;
      border-right: 2px solid var(--td-brand-color-7);
    `}
`;

const Label = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
`;
